export const upsertCustomCompletePageIconTag = (
  content: string | null | undefined,
  newIconKey: string
): string | undefined => {
  if (!newIconKey) return

  const iconRegex = /@icon\[(.*?)\]/
  const newContent = content?.replace(/@upload\[[^\]]*]/, '')?.trim() ?? ''

  const newTag = `@icon[${newIconKey}]`
  if (iconRegex.test(newContent)) {
    return newContent.replace(iconRegex, newTag)
  }
  if (newContent.trim() === 'default') {
    return newTag
  }

  return `${newTag}\n${newContent}`
}
